import { Checkbox, FormControlLabel, SxProps } from '@mui/material';
import _ from 'react';

export interface WsCheckboxProps {
  label: string;
  sx?: SxProps;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

export const WsCheckbox = ({ checked = false, label = '', ...props }: WsCheckboxProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) props.onChange(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          sx={{ ...props.sx }}
          inputProps={{ 'aria-label': 'controlled' }}
          checked={checked}
          onChange={handleChange}
        />
      }
      label={label}
      disabled={props.disabled}
    />
  );
};
